/**
 * Blog / Journal. Teksten zijn herschreven in Sarah's stem op basis van de onderwerpen
 * van de huidige site. Met een server komen ze uit de catalogus (`GET /catalog`).
 */
import type { Article } from '../core/types/content'

const MEDIK8 =
  'https://beautybewust.nl/wp-content/uploads/2026/05/Copyof20230922-PDPAsset1-CrystalRetinal1-Packshot-ROW_f6c0f90b-93b9-492c-a8af-ded1ecb370aa-1.avif'

export const articles: Article[] = [
  {
    slug: 'skincare-volgorde',
    title: 'In welke volgorde breng je skincare aan?',
    excerpt:
      'Serum, toner, exfoliant, cleanser, moisturiser, op basis van olie of juist water. Door de bomen zie je het bos niet meer. Ik leg uit wat bij jouw huid past en in welke volgorde het echt werkt.',
    category: 'Huidkennis',
    readTime: '5 min',
    date: '14 juli 2026',
    productIds: ['emerginc-kombucha-cleanser', 'emerginc-peach-toner', 'emerginc-vitamine-c-serum'],
    body: [
      {
        type: 'p',
        text: 'Bijna elke week zit er iemand bij mij in de stoel met een tas vol goede producten die samen niets doen. Niet omdat de producten slecht zijn, maar omdat de volgorde niet klopt. Een serum dat onder een dikke crème verdwijnt, bereikt je huid simpelweg niet.',
      },
      { type: 'h', text: 'De vuistregel: van dun naar dik' },
      {
        type: 'p',
        text: 'Breng producten aan van de lichtste, meest waterige textuur naar de rijkste. Waterige producten dringen snel in; olie en crème sluiten af. Draai je dat om, dan leg je een barrière voor alles wat daarna komt.',
      },
      {
        type: 'list',
        items: [
          'Reinigen — ’s avonds altijd, ’s ochtends met water of een milde cleanser',
          'Toner — brengt je huid in balans en maakt hem ontvankelijk',
          'Serum — hier zitten de werkzame stoffen, zoals vitamine C of retinol',
          'Crème of olie — voedt en sluit af',
          'SPF — overdag altijd als laatste stap',
        ],
      },
      { type: 'h', text: 'Ochtend en avond zijn niet hetzelfde' },
      {
        type: 'p',
        text: 'Overdag bescherm je: vitamine C onder je SPF is de sterkste combinatie tegen pigment en vroegtijdige veroudering. ’s Avonds herstel je: dan is er ruimte voor retinol of een rijkere olie. Retinol en vitamine C gebruik ik liever niet tegelijk bij een gevoelige huid.',
      },
      {
        type: 'tip',
        text: 'Wacht na je serum even tot het is ingetrokken, een minuutje is genoeg. Dan pas je crème.',
      },
      {
        type: 'p',
        text: 'Twijfel je over jouw volgorde of over welke producten je kunt schrappen? Stuur me een foto van je badkamerplank. Vaak is minder precies wat je huid nodig heeft.',
      },
    ],
  },
  {
    slug: 'medik8-nieuw-in-de-webshop',
    title: 'Medik8: nieuwe productlijn online',
    excerpt:
      'Naast emerginC werk ik nu ook met Medik8: wetenschappelijk onderbouwd, vegan, en opgebouwd rond vitamine A en C. Waarom deze lijn, en waar je het beste mee begint.',
    category: 'Producten',
    readTime: '4 min',
    date: '3 juli 2026',
    image: MEDIK8,
    productIds: ['medik8-chrystal-retinal-1', 'medik8-daily-radiance-vitamine-c'],
    body: [
      {
        type: 'p',
        text: 'Ik voeg niet zomaar een merk toe. Een nieuwe lijn test ik maanden op mijn eigen huid en in de salon voordat hij in de webshop komt. Medik8 heeft die test glansrijk doorstaan.',
      },
      { type: 'h', text: 'Waarom deze lijn' },
      {
        type: 'p',
        text: 'Medik8 werkt met de ingrediënten waarvan het bewijs het sterkst is: vitamine A en vitamine C, in stabiele vormen en in sterktes waarin je kunt opbouwen. Dat laatste vind ik het belangrijkst — een huid die rustig mag wennen, blijft rustig.',
      },
      {
        type: 'list',
        items: [
          'Vegan en dierproefvrij',
          'Vitamine A in oplopende sterktes, zodat je veilig opbouwt',
          'Vitamine C die stabiel blijft, ook overdag',
        ],
      },
      { type: 'h', text: 'Waar begin je?' },
      {
        type: 'p',
        text: 'Nog nooit vitamine A gebruikt? Begin met Crystal Retinal 1, twee à drie avonden per week. Overdag de Daily Radiance Vitamin C met SPF 30: beschermen en egaliseren in één stap.',
      },
      {
        type: 'tip',
        text: 'Gebruik je vitamine A? Sla dan nooit je SPF over, ook niet op een grijze dag.',
      },
    ],
  },
  {
    slug: 'emerginc-spf-50-tinted',
    title: 'emerginC SPF 50+ tinted is er weer',
    excerpt:
      'Midden in de winter missen veel van jullie juist dat egale tintje. Heb je last van pigmentvlekken? Dan is deze SPF in combinatie met het vitamine C serum precies wat je nodig hebt.',
    category: 'Producten',
    readTime: '3 min',
    date: '18 juni 2026',
    productIds: ['emerginc-sun-spf-50-tinted', 'emerginc-vitamine-c-serum'],
    body: [
      {
        type: 'p',
        text: 'Hij was even uitverkocht, en ik kreeg er meer berichten over dan over welk product ook. De minerale, licht getinte SPF 50+ van emerginC is terug.',
      },
      { type: 'h', text: 'Waarom elke dag SPF' },
      {
        type: 'p',
        text: 'Zon is de grootste veroorzaker van pigmentvlekken en huidveroudering, ook op een grijze dag. Alles wat je in je huid investeert, verlies je zonder bescherming weer.',
      },
      { type: 'h', text: 'De sterkste combinatie tegen pigment' },
      {
        type: 'p',
        text: '’s Ochtends vitamine C, daarover deze SPF. Vitamine C remt de aanmaak van pigment, de SPF voorkomt nieuwe vlekken. Het lichte tintje egaliseert direct, zodat je foundation vaak kunt overslaan.',
      },
      {
        type: 'tip',
        text: 'Gebruik een flinke hoeveelheid: ongeveer twee vingerlengtes voor gezicht en hals.',
      },
    ],
  },
  {
    slug: 'energetische-facelift',
    title: 'Energetische facelift',
    excerpt:
      'Is het mogelijk om er jonger uit te zien en je jonger te voelen zonder injecties, acupunctuur of ander trauma aan het lichaam? Het antwoord is ja. Dat doet de access energetische facelift.',
    category: 'Energetisch werk',
    readTime: '6 min',
    date: '29 mei 2026',
    body: [
      {
        type: 'p',
        text: 'Je gezicht draagt alles wat je meemaakt. Spanning in je kaak, een frons die blijft staan, vermoeidheid rond je ogen. De energetische facelift werkt precies daarop.',
      },
      { type: 'h', text: 'Wat het is' },
      {
        type: 'p',
        text: 'Tijdens de behandeling leg ik mijn handen zacht op specifieke punten van je gezicht en hoofd. Er wordt niet gemasseerd of geprikt. Het doel is spanning loslaten, zodat je gezicht zich kan ontspannen en je huid weer ruimte krijgt.',
      },
      { type: 'h', text: 'Wat klanten merken' },
      {
        type: 'list',
        items: [
          'Een zachtere, meer ontspannen uitstraling',
          'Minder spanning in kaak en voorhoofd',
          'Diepe rust, vaak nog dagen daarna',
        ],
      },
      {
        type: 'p',
        text: 'Ik combineer het graag met een bindweefselmassage: het één werkt op het weefsel, het ander op wat eronder zit. Nieuwsgierig of het bij je past? Stuur me gerust een bericht.',
      },
    ],
  },
  {
    slug: 'droge-huid-in-de-winter',
    title: 'Droge huid in de winter',
    excerpt:
      'Vanaf de herfst kan je huid flink lijden onder de droogte. Wat je van binnenuit kunt doen met voeding, en wat je huid van buitenaf nodig heeft.',
    category: 'Huidkennis',
    readTime: '7 min',
    date: '11 mei 2026',
    productIds: ['lipid-balance-cleansing-oil', 'total-moisture-daily-facial-cream', 'rawceuticals-facial-oil'],
    body: [
      {
        type: 'p',
        text: 'Kou buiten, verwarming binnen: je huid verliest in de winter sneller vocht dan hij kan aanvullen. Het gevolg is een trekkerig gevoel, schilfertjes en soms roodheid.',
      },
      { type: 'h', text: 'Van binnenuit' },
      {
        type: 'list',
        items: [
          'Gezonde vetten: avocado, noten, lijnzaad en vette vis',
          'Genoeg water en kruidenthee, ook als je geen dorst hebt',
          'Minder suiker en alcohol, die je huid extra uitdrogen',
        ],
      },
      { type: 'h', text: 'Van buitenaf' },
      {
        type: 'p',
        text: 'Reinig milder: een melkachtige cleanser in plaats van een schuimende. Kies een rijkere crème en sluit ’s avonds af met een paar druppels olie. Douche niet te heet.',
      },
      {
        type: 'tip',
        text: 'Breng je crème aan op een licht vochtige huid, dan houdt hij het vocht beter vast.',
      },
      {
        type: 'p',
        text: 'Blijft je huid trekken, ook met een goede routine? Dan kan er iets anders spelen. Laat het me weten, dan kijk ik mee.',
      },
    ],
  },
  {
    slug: 'waarom-emerginc',
    title: 'Waarom emerginC jouw nieuwe skincare routine is',
    excerpt:
      'Duurzaam is een product dat zin heeft en doet waarvoor het gemaakt is. Daarom werk ik met emerginC: cosmeceutical formules, herplant bos en de nieuwste plantbased ingrediënten.',
    category: 'Producten',
    readTime: '5 min',
    date: '22 april 2026',
    productIds: ['emerginc-vitamine-c-serum', 'emerginc-kombucha-cleanser'],
    body: [
      {
        type: 'p',
        text: 'Ik heb in twintig jaar met veel merken gewerkt. emerginC is het merk waar ik bij ben gebleven, en dat heeft een reden.',
      },
      { type: 'h', text: 'Cosmeceutical: tussen cosmetica en medicijn' },
      {
        type: 'p',
        text: 'emerginC werkt met werkzame stoffen in concentraties die je huid echt veranderen, gecombineerd met plantaardige ingrediënten. Je ziet resultaat, niet alleen een prettig gevoel.',
      },
      { type: 'h', text: 'Duurzaam op een manier die telt' },
      {
        type: 'list',
        items: [
          'Vegan en dierproefvrij',
          'Voor elk verkocht product wordt een boom geplant',
          'Formules die doen wat ze beloven, dus minder verspilde potjes',
        ],
      },
      {
        type: 'p',
        text: 'Wil je beginnen? Start met de cleanser en het vitamine C serum. Die twee vormen de basis van bijna elke routine die ik opstel.',
      },
    ],
  },
]
